"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isoStringToDateWithoutTimezone;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
function isoStringToDateWithoutTimezone(ISOString) {
  if (typeof ISOString === 'string') {
    var _ISOString$split = ISOString.split(/[^0-9]/),
      _ISOString$split2 = (0, _slicedToArray2.default)(_ISOString$split, 7),
      _ISOString$split2$ = _ISOString$split2[0],
      year = _ISOString$split2$ === void 0 ? null : _ISOString$split2$,
      _ISOString$split2$2 = _ISOString$split2[1],
      month = _ISOString$split2$2 === void 0 ? null : _ISOString$split2$2,
      _ISOString$split2$3 = _ISOString$split2[2],
      day = _ISOString$split2$3 === void 0 ? null : _ISOString$split2$3,
      _ISOString$split2$4 = _ISOString$split2[3],
      hour = _ISOString$split2$4 === void 0 ? null : _ISOString$split2$4,
      _ISOString$split2$5 = _ISOString$split2[4],
      minute = _ISOString$split2$5 === void 0 ? null : _ISOString$split2$5,
      _ISOString$split2$6 = _ISOString$split2[5],
      second = _ISOString$split2$6 === void 0 ? null : _ISOString$split2$6,
      _ISOString$split2$7 = _ISOString$split2[6],
      millisecond = _ISOString$split2$7 === void 0 ? null : _ISOString$split2$7;
    return new Date(year, month && month - 1 || null, day, hour, minute, second, millisecond);
  }
  return undefined;
}